import { Union, Record } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { menuItemToObj, MenuItem_$reflection } from "../../Interop/Antd/Menu.fs.js";
import { union_type, string_type, bool_type, record_type, array_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { createObj } from "../../fable_modules/fable-library-js.4.18.0/Util.js";
import { map } from "../../fable_modules/fable-library-js.4.18.0/List.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.18.0/Array.js";
import * as react from "react";
import { Dropdown as Dropdown_1 } from "antd";

export class DropdownMenuProps extends Record {
    constructor(items) {
        super();
        this.items = items;
    }
}

export function DropdownMenuProps_$reflection() {
    return record_type("Loop54.Portal.WebUI.Components.Dropdown.DropdownMenuProps", [], DropdownMenuProps, () => [["items", array_type(MenuItem_$reflection())]]);
}

export class DropdownProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Arrow", "Label", "Menu", "Trigger", "Placement"];
    }
}

export function DropdownProps_$reflection() {
    return union_type("Loop54.Portal.WebUI.Components.Dropdown.DropdownProps", [], DropdownProps, () => [[["Item", bool_type]], [["Item", string_type]], [["Item", DropdownMenuProps_$reflection()]], [["Item", string_type]], [["Item", string_type]]]);
}

export function Dropdown(props, elems) {
    const propsObj = createObj(map((_arg) => {
        switch (_arg.tag) {
            case 1:
                return ["label", _arg.fields[0]];
            case 2:
                return ["menu", {
                    items: map_1(menuItemToObj, _arg.fields[0].items),
                }];
            case 3:
                return ["trigger", _arg.fields[0]];
            case 4:
                return ["placement", _arg.fields[0]];
            default:
                return ["arrow", _arg.fields[0]];
        }
    }, props));
    return react.createElement(Dropdown_1, propsObj, ...elems);
}

